import React from 'react';
import image from '../../img/about-first.jpg';

const AboutUsFirst = () => {
  return (
    <div>
      <div className="container w-10/12 mx-auto">
        <div className="md:flex items-center">
          <div className="md:w-2/5 py-10 shadow border rounded-3xl ">
            <img className="rounded-3xl mx-auto w-10/12" src={"https://images.unsplash.com/photo-1668062284652-f98903857aa3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80"} alt="" />
          </div>
          <div className="md:w-1/2 md:px-16">
            <h2 className="text-2xl md:text-4xl pt-4 text-blueButton font-bold">
              Our Commitment to Patient Care and Satisfaction
            </h2>
            <p className="pt-4 pb-2  text-xl text-justify md:text-base">
              At our dermatology clinic, we pride ourselves on offering
              state-of-the-art facilities and the latest technologies to provide
              the highest level of care to our patients. Our clinic is designed
              to create a comfortable and welcoming environment where you can
              receive the best possible treatment for your skin concerns.
            </p>
            <p className="pb-4 pt-2 text-xl text-justify md:text-base">
              Our clinic is equipped with the latest diagnostic and treatment
              technologies to ensure accurate diagnoses and effective
              treatments. We use advanced imaging tools and screening
              technologies to provide comprehensive assessments of your skin,
              helping us to develop personalized treatment plans tailored to
              your individual needs.
            </p>
            {/* <h3 className="primary-color text-xl font-semibold">
              Randon Pexon, Head of Clinic
            </h3> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsFirst;
